<template>
    <div class="shop-info">
        <div class="shop-header">
            <img :src="localWeComUserInfo.avatar_url" alt="Logo" class="shop-logo">
            <div class="shop-details" @click="handleClick">
                <div class="shop-name">{{ localDepartmentdata?.department_name }}-{{ localDepartmentdata?.position_name }} <img
                        src="@/assets/img/home/ico-20.png" class="shop-arrow" alt=""></div>
                <div class="date-info">{{ dateStr }}</div>
            </div>
        </div>
        <div class="greeting">{{ period }}好，{{ localWeComUserInfo?.shop_clerk_info?.name }}</div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { onMounted, ref, watch } from 'vue'
const router = useRouter()

// 定义props，接收父组件传递的数据
const props = defineProps({
  weComUserInfo: {
    type: Object,
    default: () => ({})
  },
  departmentdata: {
    type: Object,
    default: () => ({})
  }
})

// 本地响应式数据，优先使用props，如果没有则从localStorage获取
const localWeComUserInfo = ref(props.weComUserInfo || JSON.parse(localStorage.getItem('weComUserInfo')) || {});
const localDepartmentdata = ref(props.departmentdata || JSON.parse(localStorage.getItem('departmentdata')) || {});

// 监听props变化，更新本地数据
watch(() => props.weComUserInfo, (newVal) => {
  if (newVal) {
    localWeComUserInfo.value = newVal;
  }
}, { deep: true });

watch(() => props.departmentdata, (newVal) => {
  if (newVal) {
    localDepartmentdata.value = newVal;
  }
}, { deep: true });

//在mounted中从localStorage获取，确保父组件的API调用已经完成
onMounted(() => {
  if (!props.weComUserInfo || Object.keys(props.weComUserInfo).length === 0) {
    localWeComUserInfo.value = JSON.parse(localStorage.getItem('weComUserInfo')) || {};
  }
  if (!props.departmentdata || Object.keys(props.departmentdata).length === 0) {
    localDepartmentdata.value = JSON.parse(localStorage.getItem('departmentdata')) || {};
  }
});
//获取日期，格式为8月22日，星期五
const date = new Date();
const month = date.getMonth() + 1;
const day = date.getDate();
const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][date.getDay()];
const dateStr = `${month}月${day}日，${week}`;
//6-12点为上午好，12-18点为下午，18-次日6点提示晚上好。
const hour = date.getHours();
const period = hour < 12 ? '上午' : hour < 18 ? '下午' : '晚上';

//点击店铺信息，跳转到我的部门
const handleClick = () => {
    router.push({ path: "/myDepartments" });
}
</script>

<style scoped lang="less">
/* 店铺信息区域 */
.shop-info {
    margin: 47px 14px 19px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .shop-header {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .shop-logo {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            margin-right: 8px;
        }

        .shop-details {
            .shop-name {
                font-size: 19px;
                font-weight: 500;
                color: #3C211F;

                .shop-arrow {
                    width: 8px;
                    height: 14px;
                    margin-left: 8px;
                }
            }

            .date-info {
                font-size: 13px;
                color: #3C211F;
                margin-top: 2px;
            }
        }
    }

    .greeting {
        font-size: 12px;
        color: #3C211F;
    }
}
</style>